import { ReactElement, useRef, useState } from 'react'

import Modal, { ModalProps } from '@mui/material/Modal'
import Box, { BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typograhpy from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Divider from '@mui/material/Divider'
import Grow from '@mui/material/Grow'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import { CancelButton, ConfirmButton } from '../Button'
import CheckSvgIcon from '../Icon/CheckSvgIcon'
import CloseSvgIcon from '../Icon/CloseSvgicon'
import { IAppModal } from '../../../compiler/global.interface'

export interface IAppModalAlertProps extends IAppModal {
    backdropTimeout?: number,
    loading?: boolean,
    status: 'success' | 'warning' | 'error' | 'confirm' | '',
    onClose?: any,
    onCancel?: any,
    onConfirm?: any,
    hideBackdrop?: boolean
}

export default function AppModalAlert({ prefix, title, suffix, hideBackdrop, open = false, sx, onClose, onCancel, onConfirm, loading, detail, status, backdropTimeout = 500, ...rest }: IAppModalAlertProps & BoxProps): ReactElement {

    const [cooldown, setCooldown] = useState(false)

    const handleClose = () => {
        onClose?.()
    };

    const handleCancel = () => {
        onCancel?.()
    };

    const textColorByStatus = {
        confirm: 'primary.dark',
        warning: 'warning.dark',
        success: 'primary.dark',
        error: 'error.dark',
    }

    const bgColorByStatus = {
        confirm: 'primary.light',
        warning: 'warning.light',
        success: 'primary.light',
        error: 'error.light',
    }

    const iconbyStatus: { [k: string]: any } = {
        confirm: <QuestionMarkIcon sx={{ fontSize: '6rem', color: 'primary.dark' }} />,
        warning: <CheckSvgIcon />,
        success: <CheckSvgIcon />,
        error: <CloseSvgIcon />,
    }

    const translateStatus = {
        error: ' ไม่สำเร็จ',
        success: ' สำเร็จ',
        warning: '',
        confirm: 'ยืนยันที่จะ'
    }


    return (
        <Modal
            hideBackdrop={hideBackdrop}
            open={open}
            onClose={handleClose}
            BackdropProps={{
                timeout: backdropTimeout
            }}
        >
            <Paper sx={{
                outline: 'none',
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                overflowX: 'hidden',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                width: { xs: '100%', sm: 500 }


            }}>
                <Stack>
                    <Stack pl={3} pr={2} py={2} direction={'row'} alignItems={'center'}>
                        <Typograhpy color={textColorByStatus[status]} variant='h6' sx={{ flex: 1 }}>{status === 'confirm' ? translateStatus[status] : ''}{prefix}{title}{suffix}{status !== 'confirm' ? translateStatus[status] : ''}</Typograhpy>
                        <IconButton onClick={handleClose} sx={{ flex: 0, p: 1 }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Divider />
                    <Stack px={3} py={4} alignItems={'center'} justifyContent={'flex-start'} spacing={4} maxHeight={300} overflow={'auto'}>
                        <Grow in={true}>
                            <Box sx={{ flexShrink: 0, display: 'grid', placeContent: 'center' }} width={128} height={128} margin={'0 auto'} borderRadius={140} bgcolor={bgColorByStatus[status]}>
                                {iconbyStatus[status]}
                            </Box>
                        </Grow>
                        <Typograhpy color={textColorByStatus[status]} variant="subtitle1" textAlign={'center'} lineHeight={'130%'}>{detail}</Typograhpy>
                    </Stack>
                    <Divider />
                    <Stack sx={{
                        opacity: cooldown ? 0.4 : 1,
                        pointerEvents: cooldown ? 'none' : 'auto'
                    }} px={3} py={2} direction={'row'} justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
                        {status !== 'confirm' && onClose && (<CancelButton disabled={loading} onClick={handleClose}>ปิด</CancelButton>)}
                        {status === 'confirm' && onCancel && (<CancelButton disabled={loading} onClick={handleCancel}>ยกเลิก</CancelButton>)}
                        {status === 'confirm' && onConfirm && (<ConfirmButton loading={loading} disabled={loading} onClick={onConfirm}>ตกลง</ConfirmButton>)}
                    </Stack>
                </Stack>
            </Paper>
        </Modal>
    );
}

